import { Validators } from '@angular/forms';
import { SampleType } from '@app/modules/service-data/types/sample.types';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { crossFieldValidator } from '@shared/validators/cross-field-validator';

export const nipptSampleValidationSet: ValidationPair = {
  children: {
    shared: {
      children: {
        doctorId: {
          validators: [Validators.required],
        },
        sampleType: {
          validators: [Validators.required],
        },
      },
      validators: [
        crossFieldValidator('otherType', 'sampleType', SampleType.Other),
      ],
    },
  },
};
